var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maxw960 mauto",attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }